import React from 'react';
import Select from 'react-select';
import { useRateStore } from '../store/RateStore';
import { balticRoutes } from '../models/BalticRoute';

const BalticRoute = () => {
    const store = useRateStore();

    const handleBalticRouteChange = (event) => {
        const route = event ? event : null;
        store.setBalticRoute(route);
    };

    return (
        <div
            className="inline"
            style={{
                width: '130px',
            }}
        >
            <Select
                className="basic-single"
                classNamePrefix="list"
                isSearchable={false}
                options={balticRoutes}
                onChange={handleBalticRouteChange}
                value={store.balticRoute}
                openMenuOnFocus={true}
                menuPlacement="auto"
                placeholder="Baltic Route"
            />
        </div>
    );
};

export default BalticRoute;
